import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { SignInComponent } from '../sign-in/sign-in.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  hide: boolean;
  passwordStrength: number;
  meterMessage: string;
  token: any;

  constructor(public dialog: MatDialog, private dataService: DataService, private route: ActivatedRoute, private router: Router,
              public dialogRef: MatDialogRef<ResetPasswordComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
      this.token = this.data.token;
      this.hide = true;
      this.meterMessage = '';
      this.passwordStrength = 0;
  }

  ngOnInit(): void {
    this.resetPasswordForm = new FormGroup({
      password: new FormControl(null, [Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}/)]),
    });
  }

  onStrengthChanged(strength: number) {
    this.passwordStrength = strength;

    switch (strength) {
      case 0:
      case 1:
        this.meterMessage = 'Weak password';
        break;
      case 2:
        this.meterMessage = 'Fair password';
        break;
      case 3:
        this.meterMessage = 'Normal password';
        break;
      case 4:
        this.meterMessage = 'Strong password';
        break;
      default:
        this.meterMessage = '';
        break;
    }
  }

  closeDialog() {
    if (this.resetPasswordForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    const payload = {
      Password: this.resetPasswordForm.get('password')?.value,
    };
    if (this.resetPasswordForm.valid) {
      this.dataService.post('user/ResetPassword', payload, null, {name: 'ResetToken', value: this.token }).then((data) => {
        if (data.statusCode === 200) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Password resat successfully',
              buttonText: 'Ok'
            }
          });
        } else {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Expired',
              type: 'Error',
              message: 'Link has expired, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
        this.router.navigate(['/']);
      });
    }
  }

}
